import React from 'react';

// Import your SVG files
import DashboardIcon from '@/assets/Svg/dashboard.svg';
import CodeIcon from '@/assets/Svg/code.svg';
import TeamsIcon from '@/assets/Svg/teams.svg';
import WelcomeIcon from '@/assets/Svg/welcomeSvg.svg';
import TeamHeaderIcon from '@/assets/Svg/teamHeaderSvg.svg';
import InvitePlusIcon from '@/assets/Svg/invitePlus.svg';
import InviteUserIcon from '@/assets/Svg/inviteUser.svg';
import InviteRoleIcon from '@/assets/Svg/inviteRole.svg';
import InviteEmailIcon from '@/assets/Svg/inviteEmail.svg';
import LastActivityIcon from '@/assets/Svg/lastAcitivityIcons.svg';
import RuleConditionIcon from '@/assets/Svg/ruleCondition.svg';
import CheckSvg from '@/assets/Svg/CheckSvg.svg';
import TrashIcon from '@/assets/Svg/trash.svg';
import BatchCheckIcon from '@/assets/Svg/batchCheck.svg';

// Define the available icon types
export type IconType =
  | 'dashboard'
  | 'code'
  | 'teams'
  | 'welcome'
  | 'teamHeader'
  | 'invitePlus'
  | 'inviteUser'
  | 'inviteRole'
  | 'inviteEmail'
  | 'lastActivity'
  | 'ruleCondition'
  | 'check'
  | 'trash'
  | 'batchCheck';

interface SvgIconProps {
  type: IconType;
  className?: string;
  alt?: string;
  color?: 'primary' | 'default' | 'muted' | 'gray';
}

// Map icon types to their SVG files
const iconMap = {
  dashboard: DashboardIcon,
  code: CodeIcon,
  teams: TeamsIcon,
  welcome: WelcomeIcon,
  teamHeader: TeamHeaderIcon,
  invitePlus: InvitePlusIcon,
  inviteUser: InviteUserIcon,
  inviteRole: InviteRoleIcon,
  inviteEmail: InviteEmailIcon,
  lastActivity: LastActivityIcon,
  ruleCondition: RuleConditionIcon,
  check: CheckSvg,
  trash: TrashIcon,
  batchCheck: BatchCheckIcon,
};

export const SvgIcon: React.FC<SvgIconProps> = ({
  type,
  className = 'h-4 w-4',
  alt,
  color = 'default',
}) => {
  const iconSrc = iconMap[type];

  if (!iconSrc) {
    console.warn(`Icon type "${type}" not found`);
    return null;
  }

  // Define color styles based on the color prop
  const colorStyles = {
    primary: {
      filter:
        'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(246deg) brightness(104%) contrast(97%)',
    },
    default: {},
    muted: {
      filter:
        'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(246deg) brightness(104%) contrast(50%)',
    },
    gray: {
      filter:
        'brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(89%) contrast(86%)',
    },
  };

  const iconStyle = colorStyles[color];

  return (
    <img
      src={iconSrc}
      alt={alt || `${type} icon`}
      className={className}
      style={iconStyle}
    />
  );
};

// Export individual icons for direct use
export {
  DashboardIcon,
  CodeIcon,
  TeamsIcon,
  WelcomeIcon,
  TeamHeaderIcon,
  InvitePlusIcon,
  InviteUserIcon,
  InviteRoleIcon,
  InviteEmailIcon,
  LastActivityIcon,
  RuleConditionIcon,
  CheckSvg,
  TrashIcon,
  BatchCheckIcon,
};
